module.exports = __webpack_public_path__ + "img/icon_5.b2cd4c10.png";